import type { IconVariants } from '../../../ui/Icons/IconMap';
import { getCardCategories } from '../../../utils/session/selectors';
import type { CheckoutSessionsResponse } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';

const statusVariants = {
  merchantNotConfiguredForManufacturerCard: {
    text: 'This payment method is not accepted by this merchant.',
    iconName: 'warningNotificationIcon',
  },
} as const;

export const generatePaymentMethodError = (
  initialSessionData: CheckoutSessionsResponse,
) => {
  const cardCategoriesConfig = getCardCategories(
    initialSessionData,
  );
  const status: {
    text: string;
    iconName: IconVariants;
    chipType: 'Invalid';
  }[] = [];

  if (!cardCategoriesConfig) {
    status.push({
      ...statusVariants.merchantNotConfiguredForManufacturerCard,
      chipType: 'Invalid',
    });
  }

  return status;
};
